export const ActionTypes = {
  FETCH_DOWNTIME_CATEGORIES: 'services/downtimeCategories/fetch_downtime_categories',
  FETCH_ALL_BY_FACTORY_ID: 'services/downtimeCategories/fetch_all_by_factory_id',
  SET_ALL_BY_FACTORY_ID: 'services/downtimeCategories/set_all_by_factory_id',
  FETCH_ALL_SUCCESS: 'services/downtimeCategories/fetch_all_success',
  SET_LOADER_STATUS: 'services/downtimeCategories/set_loader_status',
  SET_ALL: 'services/downtimeCategories/set_all',
  ADD_OR_UPDATE_DOWNTIME_CATEGORY: 'services/downtimeCategories/add_or_update_downtime_category',
  DELETE_DOWNTIME_CATEGORY: 'services/downtimeCategories/delete_downtime_category',
};

const fetchDowntimeCategories = ({ downtimeCategoryParams }) => ({
  downtimeCategoryParams,
  type: ActionTypes.FETCH_DOWNTIME_CATEGORIES,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allDowntimeCategory }) => ({
  allDowntimeCategory,
  type: ActionTypes.SET_ALL,
});

const addorUpdateDowntimeCategory = ({ downtimeCategoryData, actionName, downtimeCategoryParams }) => ({
  downtimeCategoryData,
  actionName,
  downtimeCategoryParams,
  type: ActionTypes.ADD_OR_UPDATE_DOWNTIME_CATEGORY,
});

const deleteDowntimeCategory = ({ id, downtimeCategoryParams }) => ({
  id,
  downtimeCategoryParams,
  type: ActionTypes.DELETE_DOWNTIME_CATEGORY,
});

export default {
  fetchDowntimeCategories,
  setAll,
  setLoader,
  addorUpdateDowntimeCategory,
  deleteDowntimeCategory,
};
